import { Link } from "react-router-dom";
import styles from "./LinkWrapper.module.scss";
import classNames from "classnames";
const LinkWrapper = ({
  className,
  link,
  component,
  color = "black",
  target = "_self",
}) => {
  return (
    <div className={classNames(styles["link-wrapper"], className)}>
      <Link
        style={{ color: color }}
        to={link}
        className={styles["link"]}
        target={target}
        reloadDocument
      >
        {component}
      </Link>
    </div>
  );
};

export default LinkWrapper;
